<template>
    <section class="hero is-fullheight" style="min-height: 100%">
        <div class="hero-body">
            <div class="container has-text-centered">
                <b-icon icon="emoticon-happy-outline" size="is-large" />
                <p>{{ $t('The item was not found.') }}</p>
            </div>
        </div>
    </section>
</template>
